import { Module } from "types/generated";

export const getDefaultValues = (module: Module) => {
  return {
    space: module.spaceDetails.id,
    labels: module.labels.map((value) => ({ value })),
    description: module.description || "",
  };
};
